import ExternalLink from "@/components/ui/ExternalLink";
import InfoPageLayout from "@/components/templates/infoPage/InfoPageLayout";
import InfoPageSection from "@/components/templates/infoPage/InfoPageSection";
import {
  InfoPageList as Ul,
  InfoPageListItem as Li,
} from "@/components/templates/infoPage/InfoPageList";
import OfficialLINE from "@/components/ui/OfficialLINE";
import { OFFICIAL_LINE } from "@/constants/common";

const ReturnPolicyPage = () => {
  return (
    <InfoPageLayout
      pageTitle="退換貨政策"
      bannerImage={{
        default: "/images/banner-shopping-info.jpg",
        desktop: "/images/banner-shopping-info.jpg",
      }}
      breadcrumbs={[{ label: "首頁", path: "/" }, { label: "退換貨政策" }]}
      ogImage="/images/banner-shopping-info-og.jpg"
      bannerImagAlign="right"
    >
      <p>
        感謝您喜歡小院咖啡的商品，為保障您的權益並維持商品品質，請您於購買前詳閱以下退換貨說明。
      </p>

      <InfoPageSection title="關於七天鑑賞期（猶豫期）">
        <Ul as="ul">
          <Li>
            咖啡豆及咖啡粉屬於「易於腐敗、保存期限較短」之食品，其烘焙後的香氣與風味會隨時間快速變化。由於保存期限通常少於七日，或即使稍長但解約時可能接近到期，均不適合退還後再出售。根據《消費者保護法》第
            19 條第 2 項規定，「易於腐敗、保存期限較短」之食品，
            <b className="underline">非商品瑕疵情況下，恕不適用七天鑑賞期</b>。
          </Li>
          <Li>依消費者要求客製化之商品：若為客製烘焙、或標註專屬包裝之訂單，亦不適用鑑賞期。</Li>
        </Ul>
      </InfoPageSection>

      {/* <InfoPageSection title="非食品類商品退貨說明">
        <Ul>
          <Li>
            除上述情形外，若您購買的為非食品類商品（例如器具、濾杯、週邊商品等），您可於收到商品後七日內（含假日）依消保法行使退貨權利。
          </Li>
          <Li>退回商品須保持完整、未使用及全新狀態，包含包裝盒、配件、發票與贈品等。</Li>
          <Li>
            請您透過
            <OfficialLINE />
            通知我們退貨需求，我們將於確認後協助後續處理。
          </Li>
        </Ul>
      </InfoPageSection> */}

      <InfoPageSection title="商品瑕疵與損壞處理">
        <p>
          在您收到貨品後，請儘速確認您所訂購的商品，若您收到的商品有下列情形，請於收貨後 24
          小時內透過
          <OfficialLINE />
          與我們聯繫：
        </p>
        <Ul>
          <Li>包裝破損</Li>
          <Li>寄錯商品、規格不符</Li>
        </Ul>
        <p>我們將協助您更換新品或辦理退貨退款，運費由我們負擔。</p>
        <p>( 因個人口味或沖煮方式造成風味差異，恕不接受退換貨。)</p>
      </InfoPageSection>

      <InfoPageSection title="退換貨申請方式">
        <p>
          如您需辦理退換貨時，請透過
          <OfficialLINE />
          於我們聯繫，並提供以下資訊，方便我們儘速處理：
        </p>
        <Ul>
          <Li>訂單編號</Li>
          <Li>姓名、聯絡電話與 Email</Li>
          <Li>退、換貨原因與問題說明</Li>
          <Li>照片（若為瑕疵或寄錯情形）</Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="退貨注意事項">
        <Ul>
          <Li>
            退貨時請保持商品完整狀態，包含主要商品、包裝及贈品等均無任何遺漏，連同原來的包裝一併退回。
          </Li>
          <Li>
            若商品因人為因素（如刮傷、磨損、髒污、拆封使用等）導致無法回復原狀，本店有權酌收整新費用或扣除相應金額。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="聯絡我們">
        <p>若您對訂單或退換貨有任何疑問，歡迎隨時透過以下方式與我們聯繫：</p>
        <Ul>
          <Li>
            LINE 官方帳號：
            <ExternalLink href={OFFICIAL_LINE.LINK}>{OFFICIAL_LINE.AT_ID}</ExternalLink>
          </Li>
        </Ul>
      </InfoPageSection>
    </InfoPageLayout>
  );
};

export default ReturnPolicyPage;
